import { render, staticRenderFns } from "./AddPrepCourse.vue?vue&type=template&id=6909b40e&"
import script from "./AddPrepCourse.vue?vue&type=script&lang=js&"
export * from "./AddPrepCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports